<div class="div">
    <button type="button" class="btn btn-orange btn-m btn-label waves-effect waves-light" (click)="stripIntegration()"><i class="ri-add-line label-icon align-middle fs-16 me-2"></i>Purchase product</button>
</div>